import { Theme } from '@mui/material';
import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { teceoGreen } from '../Theme';

const sizesSpacingConfig = {
  extraSmall: 0.75,
  small: 1,
  medium: 2,
  default: 2.5,
  large: 3,
};

const getBackgroundColor = (color: string, theme: Theme) => {
  switch (color) {
    case 'success':
      return theme.palette.success.main;
    case 'error':
      return theme.palette.error.main;
    case 'warning':
      return theme.palette.warning.main;
    case 'info':
      return theme.palette.info.main;
    case 'disabled':
      return theme.palette.action.disabled;
    case 'primary':
      return theme.palette.primary.main;
    case 'secondary':
      return theme.palette.secondary.main;
    case 'tertiary':
      return teceoGreen;
    default:
      return color;
  }
};

const useStyles = makeStyles<DotProps>()((theme: Theme, { color, size = 'small' }) => ({
  root: {
    backgroundColor: getBackgroundColor(color, theme),
    minWidth: theme.spacing(sizesSpacingConfig[size]),
    height: theme.spacing(sizesSpacingConfig[size]),
    borderRadius: theme.spacing(sizesSpacingConfig[size]),
    padding: theme.spacing(1 / 6),
    display: 'block',
  },
}));

interface DotProps {
  color: string | 'success' | 'error' | 'warning' | 'info' | 'disabled' | 'primary' | 'secondary';
  size?: keyof typeof sizesSpacingConfig;
}

const Dot = ({ size = 'small', ...props }: DotProps) => {
  const { classes } = useStyles({ size, ...props });

  return <span className={classes.root} />;
};

export default memo(Dot);
